<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtitle"><a id="page_1"></a>JUST ONE KISS</h2>
<p class="noindent">It wasn’t the photographer’s lights that were making Bridget warm and turning her cheeks pink. It was Jonas, standing under the mistletoe … waiting for her. In the cream-colored fisherman’s sweater and those worn jeans, he looked utterly masculine and sexier than any man had a right to be. Bridget was grateful that her daughter had left for a few minutes. If the photographer asked her to kiss Jonas, she didn’t know what she would do.</p>
<p class="indent">“Go for it!” Gil said loudly. “Give the man a kiss. How can you resist?”</p>
<p class="indent">She couldn’t. She couldn’t even think of a reason to refuse.</p>
<a id="page_2"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Fm01.vue?31f25266